import React, { useState, useEffect } from 'react';
import { ContentHeader, Loader } from '@components';
import { useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { updateProfile } from '../../services/auth';
import { toast } from 'react-toastify';


const Profile = () => {
  const user = useSelector((state: any) => state.auth.currentUser);
  const [isLoading, setLoading] = useState(false);
  const [fillData, setFillData] = useState({
    name: '',
    email: '',
    role_id: '',
    sales_num: '',
    agent_id: '',
    as_400_id: '',
    windows_id: '',
    depot: ''
  }); 
  useEffect(() => {
     setFillData({
      name: user.name,
      email: user.email,
      role_id: user.role_id,
      sales_num: user.agentDetail.sales_num,
      agent_id: user.agentDetail.agent_id,
      as_400_id: user.agentDetail.as_400_id,
      windows_id: user.agentDetail.windows_id,
      depot: user.agentDetail.depot
    });
    }, [])    
  const updateProfileData = (name: string, password: string) => {
    setLoading(true);
    updateProfile({ name: name, password: password }).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (resp.Acknowledge == 1) {
        toast.success('Profile Successfully updated!');
      } else {
        toast.error('Internal Server Error!');
      }
    }).catch(err => {
      setLoading(false);
      toast.error('Internal Server Error!');
    });
  };

  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: {
      name: user.name,
      password: '',
      passwordRetype: ''
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Required'),
      password: Yup.string()
        .min(5, 'Must be 5 characters or more')
        .max(30, 'Must be 30 characters or less'),
      passwordRetype: Yup.string()
        .min(5, 'Must be 5 characters or more')
        .max(30, 'Must be 30 characters or less')
        .when('password', {
          is: (val: string) => !!(val && val.length > 0),
          then: Yup.string().oneOf(
            [Yup.ref('password')],
            'Both password need to be the same'
          )
        })
    }),
    onSubmit: (values) => {
      updateProfileData(values.name, values.password);
    }
  });


  return (
    <>
      <ContentHeader title="Profile" />
      <section className="content">
        <div className="container-fluid">
          <div className="col-12">
            <form onSubmit={handleSubmit}>
              <div className="card card-primary">
                <div className="card-header">
                  <h3 className="card-title">Update Profile</h3>
                </div>
                <div className="card-body">
                  <div className="form-group row" >
                    <div className="form-group col-md-6">
                      <label>Name</label>
                      <Form.Control
                        name="name"
                        type="text"
                        placeholder="Name"
                        onChange={handleChange}
                        value={values.name}
                        isValid={touched.name && !errors.name}
                        isInvalid={touched.name && !!errors.name}
                      />
                      {touched.name && errors.name ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>

                    <div className="form-group col-md-6">
                      <label>Email</label>
                      <input type="text" name="email" className="form-control " value={user.email} readOnly />
                    </div>
                    <div className="form-group col-md-12">
                      <label>Reset your password (Leave blank password fields if you don't wants to reset
                        password)</label>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Password</label>
                      <Form.Control
                        name="password"
                        type="password"
                        placeholder="Password"
                        onChange={handleChange}
                        value={values.password}
                        isValid={values.password && touched.password && !errors.password}
                        isInvalid={values.password && touched.password && !!errors.password}
                      />
                      {touched.password && errors.password ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.password}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Confirm Password</label>
                      <Form.Control
                        name="passwordRetype"
                        type="password"
                        placeholder="Confirm Password"
                        onChange={handleChange}
                        value={values.passwordRetype}
                        isValid={values.passwordRetype && touched.passwordRetype && !errors.passwordRetype}
                        isInvalid={values.passwordRetype && touched.passwordRetype && !!errors.passwordRetype}
                      />
                      {touched.passwordRetype && errors.passwordRetype ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.passwordRetype}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>

                     <div className="form-group col-md-12 mt-3">
                      <h4>Agent Details</h4>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Salesman Number</label>
                        <Form.Control
                          id="sales_num"
                          name="sales_num"
                          type="text" 
                          placeholder=""
                          value={fillData.sales_num}  
                          readOnly
                        /> 
                      </div>
                    </div>  
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Agent Id</label>
                        <Form.Control
                          id="agent_id"
                          name="agent_id"
                          type="text" 
                          placeholder=""
                          value={fillData.agent_id}  
                          readOnly
                        /> 
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Windows Id</label>
                        <Form.Control
                          id="windows_id"
                          name="windows_id"
                          type="text" 
                          placeholder=""
                          value={fillData.windows_id} 
                          readOnly 
                        /> 
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>AS400 Id</label>
                        <Form.Control
                          id="as_400_id"
                          name="as_400_id"
                          type="text" 
                          placeholder=""
                          value={fillData.as_400_id}
                          readOnly 
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Depot</label>
                        <Form.Control
                          id="depot"
                          name="depot"
                          type="text" 
                          placeholder=""
                          value={fillData.depot} 
                          readOnly 
                        /> 
                      </div>
                    </div>

                  </div>
                </div>


                <div className="card-footer">
                  <button type="submit" className="btn btn-primary">Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Profile;
